module.exports = __webpack_public_path__ + "static/media/cloud-a-v3.e970a44b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-a-v3.svg
// module id = 92
// module chunks = 0